export const BASE_PATH = "https://cgclinic.app/api/v0".replace(/\/+$/, "");
